<div class="as-row as-justify-end">
  <mat-icon
    svgIcon="ic-close-green"
    class="as-pointer"
    mat-dialog-close
  ></mat-icon>
</div>
@if (data === 'terms') {
<div class="as-terms">
  <h2>Términos y Condiciones</h2>
  <p>
    Al registrar o actualizar los datos de su tarjeta Club, acepta lo siguiente:
  </p>
  <p>
    <strong>Acumulación de Puntos:</strong> Al utilizar su tarjeta Club en sus
    compras, obtendrá puntos que serán utilizables para obtener descuentos en
    sus siguientes compras.
  </p>
  <ul>
    <li>Cada $110.00 de compra genera 5 puntos.</li>
    <li>
      Los puntos tendrán vigencia de 2 meses: Enero–Febrero, Marzo-Abril,
      Mayo-Junio, Julio-Agosto, Septiembre-Octubre y Noviembre-Diciembre.
    </li>
    <li>El monto máximo para aplicar descuento será de $8,000 por ticket.</li>
    <li>Las compras donde se aplican descuento no generan puntos.</li>
    <li>
      Las tarjetas telefónicas prepagadas, tiempo aire, abono de Alsuper Card o
      pagos de servicios no acumulan puntos y tampoco se les puede aplicar
      descuento.
    </li>
    <li>
      No podrá realizarse la devolución de un artículo si es de una compra con
      descuento aplicado.
    </li>
  </ul>
  <p>
    <strong>Límite de Acumulación:</strong> Los puntos se acumularán de manera
    bimestral, hasta un tope de 5,000 puntos por bimestre.
  </p>
  <p>
    <strong> Restricciones en Ventas:</strong> Nos reservamos el derecho de
    vender a mayoristas o revendedores. Se prohíbe estrictamente la venta a
    mayoreo de bebidas alcohólicas.
  </p>
  <p>
    <strong>Comportamiento Inadecuado:</strong> En caso de detectar
    comportamientos fuera de lo establecido, se podrá realizar el bloqueo de la
    tarjeta.
  </p>
  <p>
    <strong>Uso de Datos Personales:</strong> La información que nos proporcione
    será utilizada para el registro de su tarjeta y para ofrecerle ofertas
    especiales e información acerca de Alsuper o artículos de su interés.
    Alsuper se reserva el derecho de uso de la información facilitada por
    nuestros clientes.
  </p>
</div>
} @if (data === 'privacy') {
<app-privacy [modal]="true"></app-privacy>

}
